import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import { CSSProperties } from 'react';

export const chartWrapper: SxProps<Theme> = {
  height: 450,
};

export const loaderWrapper: SxProps<Theme> = {
  width: '100%',
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

export const tooltipWrapperStyle: CSSProperties = {
  zIndex: 10,
};
